import createElement from '../logical-components/createElement';
// Global helpers
import svgs from './svgs';
import renderText from '../logical-components/renderText';
import Input from './input/field';
import Button from './input/button';
import './scss/rememberMe-organisations.scss';
// Message
var MessageComponent = function () {
    var container = createElement('div', [
        { type: 'class', value: '_msnlq-ae-c' },
    ]);
    container.innerHTML = "\n        <div class='_msnlq-ae-s-me'>\n            <h4> ".concat(renderText('actions.submit.success.title'), " </h4>\n            <p> ").concat(renderText('actions.submit.success.message'), " </p>\n        </div>\n        <div class='_msnlq-ae-e-me'>\n            <h4> ").concat(renderText('actions.submit.error.title'), " </h4>\n            <p> ").concat(renderText('actions.submit.error.message'), " </p>\n        </div>\n    ");
    return container;
};
var actions = [
    {
        icon: svgs.write,
        title: renderText('actions.write.title'),
        type: 'write',
    },
    {
        icon: svgs.flower,
        title: renderText('actions.flower.title'),
        type: 'flower',
    },
    {
        icon: svgs.candle,
        title: renderText('actions.candle.title'),
        type: 'candle',
    },
];
// Forms
var FormsComponent = function (_a) {
    var type = _a.type, handleChange = _a.handleChange, onSubmit = _a.onSubmit;
    var template = createElement('div');
    if (type === 'write') {
        template.appendChild(Input({
            label: renderText('actions.form.message.label'),
            placeholder: renderText('actions.form.message.placeholder'),
            onChange: function (e) {
                handleChange(type, 'message', e.target.value);
            },
            id: "".concat(type, "-form-message"),
            fieldType: 'textarea',
        }));
    }
    template.appendChild(Input({
        label: renderText('actions.form.firstName.label'),
        placeholder: renderText('actions.form.firstName.placeholder'),
        onChange: function (e) {
            handleChange(type, 'firstName', e.target.value);
        },
        id: "".concat(type, "-form-firstName"),
    }));
    template.appendChild(Input({
        label: renderText('actions.form.lastName.label'),
        placeholder: renderText('actions.form.lastName.placeholder'),
        onChange: function (e) {
            handleChange(type, 'lastName', e.target.value);
        },
        id: "".concat(type, "-form-lastName"),
    }));
    template.appendChild(Input({
        label: renderText('actions.form.email.label'),
        placeholder: renderText('actions.form.email.placeholder'),
        onChange: function (e) {
            handleChange(type, 'email', e.target.value);
        },
        id: "".concat(type, "-form-email"),
    }));
    template.appendChild(Button({
        label: renderText('actions.form.button.label'),
        onClick: function () {
            onSubmit(type);
        },
    }));
    return template;
};
var rememberMeOrganisationWrapper = function (undertaker) {
    var _a, _b, _c;
    var actionsWrapper = createElement('div');
    actionsWrapper.className = '_msnlq-organisation-container';
    actionsWrapper.innerHTML = "<div class='_mnslq-org'>\n        <div>            \n            ".concat(undertaker.name ? "<div class=\"_mnslq-org-title\">".concat(undertaker.name, "</div>") : '', "\n            ").concat(undertaker.logo ? "<div class=\"_mnslq-org-logo\"><img src=\"".concat(undertaker.logo, "\" alt=\"").concat((_a = undertaker.name) !== null && _a !== void 0 ? _a : '', "\" /></div>") : '', "               \n                           \n            ").concat(undertaker.address ? "<div>".concat(undertaker.address.address, "<br />").concat(undertaker.address.postalcode, " ").concat((_c = (_b = undertaker.address.place) === null || _b === void 0 ? void 0 : _b.title) !== null && _c !== void 0 ? _c : '', "</div>") : '', "\n            ").concat(undertaker.place ? "<div>".concat(undertaker.place, "</div>") : '', "\n            ").concat(undertaker.phone ? "<div>Telefoon: <a href=\"tel:".concat(undertaker.email, "\">").concat(undertaker.phone, "</a></div>") : '', "\n            ").concat(undertaker.email ? "<div>Email: <a href=\"mailto:".concat(undertaker.email, "\">").concat(undertaker.email, "</a></div>") : '', "\n            ").concat(undertaker.website ? "<div>Website: <a href=\"".concat(undertaker.website, "\">").concat(undertaker.website, "</a></div>") : '', "\n        </div>\n    </div>");
    return actionsWrapper;
};
export default rememberMeOrganisationWrapper;
